// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"iU","modalBox":"iU","modal-mask":"iV","modalMask":"iV","close-btn":"iW","closeBtn":"iW","container":"iX","content":"iY","title":"iZ","subTitle":"i0","detail":"i1"};